module.exports = __webpack_public_path__ + "static/media/ei02.80c91d01.png";